import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      switch (err.status) {
        // case HttpStatusCode.Unauthorized:
        //   console.error('Unauthorized: You are required to login!');
        //   router.navigate(['/login']);
        //   return throwError(() => err.statusText);

        case HttpStatusCode.NotFound:
        case HttpStatusCode.InternalServerError:
          console.error('Server Error: Sorry, something went wrong on the server!');
          return throwError(() => err.statusText);

        default:
          console.error('Error: Sorry, something went wrong!', err);
          return throwError(() => err);
      }
    }),
  );
};
